import { UserInfo, useUserInfoQuery } from './query/useUserInfoQuery';

/**
 * Use only in descendants of <RequireAuth></RequireAuth>.
 */
export const useUserInfo = (): UserInfo => {
  const { data } = useUserInfoQuery();

  if (!data) {
    throw new Error(
      'Session user data is not loaded nor loading but already consumed',
    );
  }

  return data.data;
};
